module.exports = __webpack_public_path__ + "static/media/admin_white.08eb656e.svg";